import { Button, Divider, Grid, Link, Typography } from '@mui/material';
import React from 'react';
import OrganizationUpdateForm from './OrganizationUpdateForm';
import UserUpdateForm from './UserUpdateForm';
import { useNavigate } from 'react-router-dom';

export default function ProfileTab() {
  const screensize = window.innerWidth;
  const isMobile = screensize < 600;
  const navigate = useNavigate();
  return (
    <Grid container sx={{ justifyContent: 'center' }}>
      <Grid item xs={12}>
        <Grid container paddingTop={2} sx={styles.mainContainer}>
          <Grid item xs={0} md={3} />
          <Grid item container direction={'column'} xs={12} md={3} sx={styles.spaceBetween}>
            <UserUpdateForm />
          </Grid>
          <Grid item>
            <Divider orientation={isMobile ? 'horizontal' : 'vertical'} />
          </Grid>
          <Grid item container xs={12} md={3}>
            <OrganizationUpdateForm />
          </Grid>
          <Grid item xs={0} md={3} />
        </Grid>
      </Grid>
      <Grid item sx={{ textAlign: 'center' }}>
        <Typography variant='caption'>
          To delete your account or organization, please{' '}
          <Button size={'small'} onClick={() => navigate('/settings?tab=support')}>
            contact support
          </Button>
        </Typography>
      </Grid>
    </Grid>
  );
}

const styles = {
  centeredContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  spaceBetween: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  mainContainer: {
    height: '80vh',
  },
};
